import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ServicesContext, useAdminService } from '~/services';

interface WelcomeEmailProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
    onCompleted: () => void;
}
export function WelcomeEmail({ user, setServerError, onCompleted }: WelcomeEmailProps) {
    const context = React.useContext(ServicesContext);
    const { sendWelcomeEmail } = useAdminService();
    const [loading, setLoading] = React.useState(false);
    const [sent, setSent] = React.useState(false);

    async function dispatchWelcomeEmail() {
        try {
            setLoading(true);
            await sendWelcomeEmail(user.id, { handledErrors: { 400: true } });
            setLoading(false);
            setSent(true);
            onCompleted();
        } catch (e) {
            setLoading(false);
            setServerError(e.response);
        }
    }

    return !user.last_login && !sent ? (
        <Button
            onClick={dispatchWelcomeEmail}
            variant="info"
            size="sm"
            className="pull-right"
            disabled={loading}
        >
            {context.user.hasFeatureToggle('auth_one_healthcare_id_only')
                ? 'Send Activation Email'
                : 'Send Welcome Email'}
            {loading && <Spinner animation="border" role="status" size="sm" className="ms-1" />}
        </Button>
    ) : null;
}
